export type ProfileData = {
  firstName: string;
  lastName: string;
  gender: string;
  dateOfBirth: string;
  memberId: string;
  pin: string;
  relationship: string;
  ecId: string;
  address: AddressData;
  contactPoints: [
    {
      type: string;
      use: string;
      value: string;
    },
  ];
  dependents: [
    {
      firstName: string;
      lastName: string;
      gender: string;
      dateOfBirth: string;
      pin: string;
      relationship: string;
      ecId: string;
    },
  ];
  csPhoneNumber: string;
};

type AddressData = {
  type: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  city: string;
  state: string;
  postalCode: string;
  countryCode: string;
  county: string;
};

export enum PHONE_NUMBER_TYPE {
  PHONE = 'Phone',
  TEXT = 'Text',
  EMAIL = 'Email',
  OTHERS = 'Other',
}

export enum FORM_TYPE {
  MEDICATION = 'Medication Exception Request Form',
  STEP_THERAPY = 'Step Therapy Exception Request Form',
  DENTAL = 'Member Submitted Dental Claim Form',
  DIRECT_REIMBURSEMENT = 'Direct Reimbursement Claim Form',
  COB = 'Other Insurance Information/COB',
}

export enum FORM_API_TYPE {
  MEDICATION_EXCEPTION = 'medicationexception',
  STEP_THERAPY = 'steptherapy',
  DENTAL_CLAIM = 'dental-claim',
  DIRECT_REIMBURSEMENT_CLAIM = 'direct-reimbursement-claim',
}

export enum FORM_OPEN_TYPE {
  PDF_FORM = 'pdf',
  ONLINE_FORM = 'link',
}

export enum HIGHMARK_APP_TYPE {
  AMH = 'hm-allmyhealth',
  IEL = 'highmark-iel',
  BENEFICITY = 'highmark-beneficity',
}

export enum FORM_PLAN_TYPE {
  MEDICAL = 'Medical',
  DRUG = 'Drug',
  DENTAL = 'Dental',
  VISION = 'Vision',
  PHARMACY = 'Pharmacy/Rx',
  MEDICARE = 'Medicare',
  MEDIGAP = 'Medigap',
  MEDICARE_ADVANTAGE = 'Medicare Advantage',
}

export enum IS_POLICY_HOLDER_PATIENT {
  YES = 'Yes',
  NO = 'No',
}

export const STATE_VALUE = [
  'AK',
  'AL',
  'AR',
  'AS',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'GU',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MP',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VI',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
];

export const SERVICE_TYPE_VALUE = [
  'Bifocal Lenses',
  'Contact Lenses',
  'Daily Wear Contact Lens Evaluation',
  'Extended Wear Contact Lens Evaluation',
  'Contact Lenses Standard Daily Wear (1 pair)',
  'Contact Lenses Disposable',
  'Eye Examination',
  'Frames',
  'Medically Necessary Contacts ',
  'Progressive Lenses',
  'Single Vision Lenses',
  'Trifocal Lenses',
];
